// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dqROVqiHI6IEormVvd4V {
  position: absolute;
  top: 30px;
  min-width: 30px;
  right: 0;
  font-family: 'Futura PT Cond';
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  line-height: 0.7em;
  background-color: #FFF41A;
  border-left: 0.5px solid #C2A956;
  border-top: 0.5px solid #C2A956;
  border-bottom: 0.5px solid #C2A956;
  border-right: none;
  border-radius: 3px 0 0 3px;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.35);
  color: #1C1C1E;
  font-size: clamp(12px, 9cqi, 18px);
  font-weight: 700;
  letter-spacing: 0.6px;
  text-align: center;
}
.dqROVqiHI6IEormVvd4V[data-lang="cjk"] {
  padding: 6px 4px 5px 3px;
}
@media (min-height: 500px) {
  [data-view='single'][data-section='pickRandom'] .dqROVqiHI6IEormVvd4V {
    top: 38px;
  }
}
@media (min-width: 1025px) {
  .dqROVqiHI6IEormVvd4V {
    top: 38px;
    min-width: 38px;
  }
  [data-game-card-size="compact"] .dqROVqiHI6IEormVvd4V {
    top: 30px;
    min-width: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/TopGameBanner/TopGameBanner.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,0BAA0B;EAC1B,2CAA2C;EAC3C,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[".badge {\n  position: absolute;\n  top: 30px;\n  min-width: 30px;\n  right: 0;\n  font-family: 'Futura PT Cond';\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px;\n  line-height: 0.7em;\n  background-color: #FFF41A;\n  border-left: 0.5px solid #C2A956;\n  border-top: 0.5px solid #C2A956;\n  border-bottom: 0.5px solid #C2A956;\n  border-right: none;\n  border-radius: 3px 0 0 3px;\n  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.35);\n  color: #1C1C1E;\n  font-size: clamp(12px, 9cqi, 18px);\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  text-align: center;\n}\n.badge[data-lang=\"cjk\"] {\n  padding: 6px 4px 5px 3px;\n}\n@media (min-height: 500px) {\n  [data-view='single'][data-section='pickRandom'] .badge {\n    top: 38px;\n  }\n}\n@media (min-width: 1025px) {\n  .badge {\n    top: 38px;\n    min-width: 38px;\n  }\n  [data-game-card-size=\"compact\"] .badge {\n    top: 30px;\n    min-width: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `dqROVqiHI6IEormVvd4V`
};
export default ___CSS_LOADER_EXPORT___;
